import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import OrderItem from "./OrderItem";

const OrdersCard = ({ loading, orders, copy, language }) => (
  <div className="bg-[#18181B] border border-white/10 p-6" data-testid="orders-card">
    <h2 className="text-lg font-bold uppercase text-white mb-4 flex items-center gap-2"><FileText className="w-5 h-5 text-[#CCFF00]" />{copy.orders.title}</h2>
    {loading ? (
      <div className="text-center py-8"><div className="w-6 h-6 border-2 border-[#CCFF00] border-t-transparent rounded-full animate-spin mx-auto" /></div>
    ) : orders.length === 0 ? (
      <div className="text-center py-10 border border-white/10 bg-[#0A0A0A]">
        <FileText className="w-12 h-12 text-zinc-600 mx-auto mb-4" />
        <p className="text-white font-bold mb-2">{copy.orders.emptyTitle}</p>
        <p className="text-zinc-500 mb-5 text-sm">{copy.orders.emptyText}</p>
        <Link to="/pricing" className="inline-flex items-center justify-center bg-[#CCFF00] text-black px-4 py-2 font-bold text-sm uppercase hover:bg-[#AACC00] transition-colors">{copy.orders.firstOrder}</Link>
      </div>
    ) : (
      <div className="space-y-4">{orders.map((order) => <OrderItem key={order.order_id} order={order} copy={copy.orderItem} language={language} />)}</div>
    )}
  </div>
);

export default OrdersCard;
